var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47716 0 0 4.47716 0 10C0 15.5228 4.47716 20 10 20C15.5228 20 20 15.5228 20 10C19.9929 4.4801 15.5199 0.00707851 10 0ZM10.429 19.1206V17.3616C10.429 17.1247 10.2369 16.9326 10 16.9326C9.76308 16.9326 9.571 17.1247 9.571 17.3616V19.1206C4.86696 18.896 1.10403 15.133 0.879451 10.429H2.63835C2.87527 10.429 3.06735 10.2369 3.06735 10C3.06735 9.76308 2.87527 9.571 2.63835 9.571H0.879451C1.10403 4.86696 4.86696 1.10403 9.571 0.879451V2.63835C9.571 2.87527 9.76308 3.06735 10 3.06735C10.2369 3.06735 10.429 2.87527 10.429 2.63835V0.879451C15.133 1.10403 18.896 4.86696 19.1206 9.571H17.3616C17.1247 9.571 16.9326 9.76308 16.9326 10C16.9326 10.2369 17.1247 10.429 17.3616 10.429H17.3659H19.1248C18.9001 15.1346 15.1347 18.8981 10.429 19.1206Z",
    fill: "#B0B0B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5259 13.9897L10.429 9.82415V5.49553C10.429 5.25861 10.2369 5.06653 9.99998 5.06653C9.76307 5.06653 9.57098 5.25861 9.57098 5.49553V10C9.57147 10.1126 9.61614 10.2204 9.69539 10.3003L13.9125 14.5903C14.0783 14.7597 14.3501 14.7626 14.5195 14.5968C14.6889 14.4309 14.6918 14.1591 14.5259 13.9897Z",
    fill: "#B0B0B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.52792e67303f382f1b902488d2dc42af.svg";
export { ForwardRef as ReactComponent };